import Bunkers from "./Bunkers";
import Draft from "./Draft";
import FreshWater from "./FreshWater";
import Tugs from "./Tugs";

const DraftBunkersFreshWater = ({
  isArrival,
  editMode,
  isLoading,
  bunkers,
  setBunkersFuel,
  freshWater,
  setFreshWater,
  tugs,
  setTugs,
  errorsStateForTugs,
}) => {
  return (
    <>
      {/*<Draft*/}
      {/*  isArrival={isArrival}*/}
      {/*  isRequired={isRequired}*/}
      {/*  setDraft={setDraft}*/}
      {/*  draft={draft}*/}
      {/*  editMode={editMode}*/}
      {/*  isLoading={isLoading}*/}
      {/*  departurePortName={departurePortName}*/}
      {/*/>*/}
      <Bunkers
        isArrival={isArrival}
        editMode={editMode}
        isLoading={isLoading}
        bunkers={bunkers}
        setBunkersFuel={setBunkersFuel}
        freshWater={freshWater}
        setFreshWater={setFreshWater}
        tugs={tugs}
        setTugs={setTugs}
        errorsStateForTugs={errorsStateForTugs}
      />
    </>
  );
};

export default DraftBunkersFreshWater;
